import { CountryCode } from '../countryCodes'

const baseURL = 'https://bed-booking.com/'

const links: ILinks = {
  /* eslint-disable @typescript-eslint/camelcase */
  bg: 'en/registration/',
  cz: 'en/registration/',
  de: 'de/registrierung/',
  el: 'el/εγγραφή/',
  en: 'en/registration/',
  'en-US': 'en/registration/',
  es: 'es/registro/',
  fil: 'en/registration/',
  fr: 'fr/enregistrement/',
  hr: 'en/registration/',
  hu: 'en/registration/',
  in: 'en/registration/',
  it: 'it/registrazione/',
  ja: 'en/registration/',
  ko: 'en/registration/',
  ms: 'en/registration/',
  pl: 'pl/register/',
  pl_PL: 'pl/register/',
  pt: 'pt/registo/',
  pt_BR: 'pt/registo/',
  ro: 'en/registration/',
  ru: 'ru/регистрация/',
  se: 'en/registration/',
  th: 'en/registration/',
  tr: 'en/registration/',
  uk: 'en/registration/',
  /* eslint-enable */
}

export default function (lng: CountryCode): string {
  return baseURL + links[lng]
}

type ILinks = { [key in CountryCode]?: string } & { 'en-US': string }
